<template>
  <div id="footer" class="row">
    <div class="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12 quvestra">
      <router-link :to="{name: 'homepage'}"><img style="width: 50%;" src="../../static/image/logo-ballerio-black.png"/></router-link>
      <div class="title" style="padding-top:20px">TENUTA BALLERIO SOCIET&Agrave; AGRICOLA SRL</div>
      <div class="text text-footer">
        l-27047 Santa Maria della Versa (PV)
        Località Case Nuove, 9 - SP. 189
        <div class="text">P.IVA 02542850181</div>
        <div class="text">CIN: IT018143B59NIC8K5K</div>
        <div class="text">CIR: 018143-AGR-00007</div>
      </div>
    </div>
    <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12 paragrafo">
      <div class="col-xl-12 col-lg-11 title">INFORMAZIONI</div>
      <div class="text" style="margin-top: 30px">
        <div class="col-xl-12 col-lg-12" style="margin-top: 10px"><a href="../../static/documents/CondizionidiVendita.pdf" target="_blank">Condizioni di vendita</a></div>
        <div class="col-xl-12 col-lg-12"><a href="../../static/documents/DirittodiRecessoeRegoleperlaRestituzione.pdf" target="_blank">Effettuare un reso</a></div>
        <!--<div class="col-xl-12 col-lg-12"><a href="https://info.terredispirito.it/hubfs/Cookie%20Policy_tenutaquvestra.pdf " target="_blank">Cookie Policy</a></div>-->
        <div class="col-xl-12 col-lg-12"><a href="https://www.tenutaballerio.com/#/privacyCookiePolicy" target="_blank">Privacy&Cookie Policy</a></div>
        <!--<div class="col-xl-12 col-lg-12"><a href="https://info.terredispirito.it/hubfs/Privacy%20Policy_tenutaquvestra-1.pdf" target="_blank">Privacy Policy</a></div>-->
        <div class="col-xl-12 col-lg-12"><a href="../../static/documents/CondizionidUso.pdf" target="_blank">Condizioni d'uso</a></div>
      </div>
    </div>
    <div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-12 paragrafo">
      <div class="col-lg-12 title">{{$t('contacts')}}</div>
      <div class="col-lg-12 text contatti-info" style="margin-top: 30px">Email: info@tenutaballerio.com</div>
      <div class="col-lg-12 text contatti-info" style="padding-bottom: 0">Cellulare: 347.6014109</div>
      <div>
        <!--<div class="bottone" v-b-modal.modal-center><b>{{$t('newsletter')}}</b></div>-->
        <div id="formNewsletter" style="padding-left: 15px"></div>

        <!-- Modal Component -->
        <!--<b-modal v-if="step===0" id="modal-center" size="lg" centered>
          <div class="col-lg-6 subscribe">
            <p class="title">{{$t('news')}}</p>
            <p class="text">Cliccando su “iscriviti” accetti di ricevere newsletter informative ed aggiornamenti sui nostri prodotti e sugli eventi riservati.</p>
            <p class="text">I tuoi dati personali verranno utilizzati da Tenuta Ballerio per fornirti il servizio da te espressamento richiesto. Consulta la <a href="../../static/documents/PrivacyPolicy.pdf" target="_blank"><b>Privacy policy</b></a> per maggiori informazioni</p>
            <el-form class="formRichieste" ref="form" :model="form">
              <el-form-item prop="email" type="email">
                <div style="color: red; padding: 10px; text-align: center">{{ errors.first('email') }}</div>
                <el-input id="email" v-validate="'required|email'" name="email" v-model="form.email"></el-input>
              </el-form-item>
            </el-form>
            <div class="iscriviti">
              <b-button class="bottone" variant="outline-success" state="false" @click="onSubmit('form')">
                {{$t('sub')}}
              </b-button>
            </div>
          </div>
          <div class="col-lg-6 pic" style="padding-right: 0px">
            <img style="width: 100%" src="../../static/image/cantinaWineTourTop.jpg">
          </div>
        </b-modal>
        <b-modal v-if="step===1" id="modal-center" size="lg" centered>
          <div class="col-lg-6 subscribe">
            <p class="title">{{$t('news')}}</p>
            <p class="text">Grazie per essert registrato alla newsletter !<br>A breve riceverai una mail di conferma</p>
          </div>
          <div class="col-lg-6 pic" style="padding-right: 0px">
            <img style="width: 100%" src="../../static/image/cantinaWineTourTop.jpg">
          </div>
        </b-modal>-->
      </div>
      <!-- <div class="col-lg-12 text">TEL: +39 347 6014109<br>Mail: <a href="mailto:info@tenutaballerio.com">info@tenutaballerio.com</a></div>-->
    </div>
    <!--<div class="col-xl-1 col-lg-4 col-md-6 col-sm-6 col-12 paragrafo">
      <div class="col-lg-12 title">{{$t('follow')}}</div>
      <div style="display: inline-flex">
        <a style="padding-left: 15px; padding-right: 15px" href="https://www.facebook.com/tenutaballerio"
           target="_blank"
           id="face"><img src="../../static/image/facebook.png"/></a>
        <a href="https://www.instagram.com/TenutaBallerio/" target="_blank" id="insta"><img
          src="../../static/image/instagram.png"/></a>
      </div>
    </div>-->
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data() {
      return {
        step: 0,
        form: {
          email: ''
        }
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          follow: 'SEGUICI',
          contacts: 'CONTATTI',
          news: 'ISCRIVITI ALLA NOSTRA NEWSLETTER',
          newsletter: 'Iscriviti alla Newsletter',
          aggior: 'Resta sempre aggiornato sui nostri eventi ed offerte',
          sub: 'Iscriviti'
        },
        en: {
          follow: 'FOLLOW US',
          contacts: 'CONTACTS',
          news: 'SUBSCRIBE TO OUR NEWSLETTER',
          newsletter: 'Subscribe to Newsletter',
          aggior: 'Stay up to date on our events and offers',
          sub: 'Subscribe'
        }
      }
    },
    mounted: function () {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "146381812",
          formId: "754b42b0-20e0-449d-b3f9-0c8615bc0c50",
          target: "#formNewsletter"
        });
      }
    },
    methods: {
      onSubmit (formName) {
        this.$validator.validate().then(result => {
          if (result) {
            this.registrazione(formName)
          }else {
            // console.log('error submit!!')
          }
        });
      },
      registrazione(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.newsletter()
          } else {
            // console.log('error submit!!')
            return false
          }
        })
      },
      newsletter: function () {
        let data = {
          'email': this.form.email
        }
        this.step = 1
        this.$http.post('/ws-shop/order/newsletter', data).then(response => {
          // if (response.body.rc === 0) {
          //   this.step = 1
          // }
        })
      }
    }
  }
</script>

<style lang="less">
@import "../assets/less/variabili.less";
@import "../assets/less/font.less";

.modal-open {
  padding-right: 0px !important;
}

  #footer {
    color: #000000;
    line-height: 1.7;
    letter-spacing: 1px;
    margin-right: 0px;
    margin-left: 0px;
    background-color: #ffffff;
    text-align: left;
    position: relative;
    left: 0;
    bottom: 0;
    width: 100%;
    border: 1px;
    padding: 30px;
    border-bottom: .5px;
    border-bottom-style: solid;
    border-bottom-color: #000000;
    input {
      background-color: @lightBlack;
      border-color: @lightBlack;
      margin-left: 1px;
      text-align: center;
      display: inherit;
      letter-spacing: 1px;
      .set-font(@color: @lightGold)
    }
    .modal-lg {
      max-width: 1200px;
    }
    .modal-content {
      background-color: @lightBlack;
      .modal-header {
        display: none !important;
        border-bottom: 0px;
        .close {
          color: white;
        }
      }
      .modal-body {
        display: flex;
        padding: 0px;
        width: 100%;
        .subscribe {
          padding-left: 50px;
          padding-top: 30px;
          .title {
            .set-font-title(@size: 30px)
          }
          .text {
            .set-font(@size: 12px);
          }

          .form-control {
            width: 60%;
            margin: auto;
          }
          .iscriviti {
            text-align: center;
            padding-top: 5px;
            .bottone {
              width: 230px;
              background-color: @myOrange;
              border-color: @borderOrange;
              margin: auto;
              text-align: center;
              display: inherit;
              letter-spacing: 1px;
              .set-font()
            }
          }
        }
      }
      .modal-footer {
        display: none !important;
        border-bottom: 0px;
      }
      #modal-center {
      }
    }
    .title {
      margin-bottom: 10px;
      .set-font-title(@size: 20px);
      color: #000000;
    }
    .quvestra .title {
      font-size: 16px;
    }
    .text {
      .set-font();
      color: #000000;
    }
    .text a{
      .set-font();
      color: #000000;
    }
  }


@media (max-width: 767px) {
  #footer {
    padding: 15px;
    .quvestra {
      padding-bottom: 20px;
      text-align: center;
    }
    .paragrafo {
      color: #000000;
      border: 1px;
      padding: 0;
      border-left: .5px;
      border-left-style: solid;
      border-left-color: darkgray;
      .title {
        color: #000000!important;
      }
      .text a{
        color: #000000!important;
      }
      .bottone {
        .set-font(@size: 16px, @color: @lightGold)
      }
      .modal-content {
        .modal-header {
          .close {
          }
        }
        .modal-body {
          .subscribe {
            padding-left: 30px;
            .title {
              .set-font-title(@size: 30px);
            }
            .text {
              padding-bottom: 0px;
              .set-font(@size: 12px)
            }
            .form-control {
              width: 100%;
            }
            .iscriviti {
              text-align: center;
              padding-top: 5px;
              padding-bottom: 30px;
              .bottone {
                width: 130px;
                .set-font(@size: 12px)
              }
            }
          }
          .pic {
            width: 0px;
          }
        }
        .modal-footer {
          display: none !important;
          border-bottom: 0px;
        }
        #modal-center {
        }
      }
      .title {
        margin-bottom: 10px;
        .set-font-title(@size: 16px);
      }
      .text {
        padding-bottom: 20px;
        letter-spacing: 1px;
        .set-font(@size: 12px, @color: #000000);
      }
      .contatti-info {
        .set-font(@size: 16px, @color: #000000);
        letter-spacing: 1px;
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1366px) {
  #footer {
    padding: 15px;
    .quvestra {
      padding-bottom: 20px;
      text-align: center;
    }
    .paragrafo {
      margin-bottom: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue